import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {

  },
  state: {
    nationCode: null,
    nationName: null,
    imgUrl: "",
    theme: "blue"
  },
  actions: {
  },
  mutations: {
    setNationCodeAndNationName(state, data) {
      state.nationCode = data.nationCode
      state.nationName = data.nationName
    },
    setImgUrl(state,data){
      state.imgUrl = data
    },
    setTheme(state,data){
      state.theme = data
    }
  },
  getters: {

  }
})